document.addEventListener('DOMContentLoaded', function () {
  const grids = document.querySelectorAll('.reviews-grid');

  grids.forEach(function (grid) {
    const loadMoreBtn = grid.querySelector('.reviews-grid__load-more');
    const loadMoreWrap = grid.querySelector('.reviews-grid__load-more-wrap');
    const hiddenItems = grid.querySelectorAll('.reviews-grid__item--hidden');

    if (!loadMoreBtn || hiddenItems.length === 0) return;

    const cardsPerPage = parseInt(grid.dataset.cardsPerPage, 10) || 16;

    loadMoreBtn.addEventListener('click', function () {
      const stillHidden = grid.querySelectorAll('.reviews-grid__item--hidden');
      const batch = Array.from(stillHidden).slice(0, cardsPerPage);

      batch.forEach(function (item) {
        item.classList.remove('reviews-grid__item--hidden');
      });

      if (grid.querySelectorAll('.reviews-grid__item--hidden').length === 0 && loadMoreWrap) {
        loadMoreWrap.classList.add('reviews-grid__load-more-wrap--hidden');
      }
    });
  });
});
